<template>
  <v-container text-xs-center>
    <v-data-table
      style="overflow-y: auto; overflow-x: auto"
      :headers="headers"
      :items="activityList.edges"
      :search="search"
      :loading="loading"
      loading-text="Loading... Please wait"
      class="elevation-5"
      hide-default-footer
      :hide-default-header="isMobile"
      :class="{ mobile: isMobile }"
      :items-per-page="itemsPerPage"
      :page.sync="page"
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.node.USCode`]="{ item }">
        <v-chip :color="`${item.node.activityColor}`">{{
          item.node.USCode
        }}</v-chip>
      </template>
      <template v-slot:[`item.node.activityName`]="{ item }">
        <v-chip :color="`${item.node.activityColor}`">{{
          item.node.activityName
        }}</v-chip>
      </template>
      <template v-slot:[`item.node.EUCode`]="{ item }">
        <v-chip :color="`${item.node.activityColor}`">{{
          item.node.EUCode
        }}</v-chip>
      </template>
      <template v-slot:[`item.node.CANCode`]="{ item }">
        <v-chip :color="`${item.node.activityColor}`">{{
          item.node.CANCode
        }}</v-chip>
      </template>

      <template v-slot:[`item.node.HRMaxPct`]="{ item }">
        <td>{{ item.node.HRMinPct + "-" + item.node.HRMaxPct }}</td>
      </template>
      <template v-slot:[`item.node.DURATIONMax`]="{ item }">
        <td>{{ item.node.DURATIONMin + "-" + item.node.DURATIONMax }}</td>
      </template>
      <template v-slot:[`item.node.SWIMDurationMax`]="{ item }">
        <td>
          {{ item.node.SWIMDurationMin + "-" + item.node.SWIMDurationMax }}
        </td>
      </template>

      <template v-slot:top>
        <BaseToolbar toolbarTitle="Energy Zones/Activity">
          <template v-slot:toolbarSearch>
            <v-text-field
              cy-data="cy_Search_energy_Zone"
              v-model="search"
              append-icon="search"
              label="Search Activity"
              single-line
              hide-details
            ></v-text-field>
          </template>
          <template v-slot:toolbarBtn>
            <v-dialog v-model="dialog" :retain-focus="false" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-on="on" v-bind="attrs">{{
                  formTitle
                }}</v-btn>
              </template>
              <v-card height="100%" style="overflow:auto">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.activityDescription"
                          label="Activity Description"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.activityName"
                          label="Activity Name"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.activityCategory"
                          label="Activity Category"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.USCode"
                          label="US Code"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.EUCode"
                          label="Europe Code"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.CANCode"
                          label="Canadian Code"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.HRMinPct"
                          label="Heart Rate Min(%)"
                          readonly
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.HRMaxPct"
                          label="Heart Rate Max(%)"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.DURATIONMin"
                          label="Duration Min (min)"
                          readonly
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.DURATIONMax"
                          label="Duration Max (min)"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.SWIMDurationMin"
                          label="Swim Volume Minimum (meters)"
                          readonly
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.SWIMDurationMax"
                          label="Swim Volume Maximum (meters)"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.activityType"
                          label="Activity Type"
                          readonly
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.VO2maxPct"
                          label="VO2Maximum %"
                          readonly
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.WORKRest"
                          label="WORKRest Ratio"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.activityId"
                          label="Activity Id"
                          filled
                          disabled
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" text @click="close">Cancel</v-btn>
                  <v-btn
                    :disabled="!isFormValid"
                    color="secondary"
                    text
                    @click="save"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </BaseToolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item.node)">
          edit
        </v-icon>
        <v-icon small @click="deleteItem(item.node)">
          delete
        </v-icon>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import BaseToolbar from "../../base/BaseToolbar.vue";

export default {
  components: { BaseToolbar },
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      isFormValid: true,
      loading: true,
      status: "active",
      search: "",
      currentDate: new Date().toISOString().substr(0, 10),
      dialog: false,
      menu: false,
      on: "",
      name: "Default",
      pagination: {
        sortBy: "node.acitivityId",
        ascending: false,
        rowsPerPage: -1
      },
      isMobile: false,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      headers: [
        {
          text: "US Code",
          sortable: true,
          value: "node.USCode",
          width: "1%"
        },
        { text: "Heart Rate(%)", value: "node.HRMaxPct" },
        { text: "Duration(min)", value: "node.DURATIONMax" },
        { text: "Swim Volume(meters)", value: "node.SWIMDurationMax" },
        { text: "Work/Rest ration", value: "node.WORKRest" },
        { text: "Description", value: "node.activityDescription" },
        { text: "Type", value: "node.activityType" },
        { text: "CAN Code", value: "node.CANCode" },
        { text: "EU Code", value: "node.EUCode" },
        { text: "Code", value: "node.activityName" },
        { text: "VO2maxPct", value: "node.VO2maxPct" },
        { text: "Actions", value: "action", sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        "node.activityId": "",
        "node.activityName": 0,
        "node.activityDescription": 0,
        "node.activityCategory": 0,
        "node.USCode": 0,
        "node.EUCode": 0,
        "node.CANCode": 0,
        "node.HRMinPct": 0,
        "node.HRMaxPct": 0,
        "node.DURATIONMin": 0,
        "node.DURATIONMax": 0,
        "node.WORKRest": 0,
        "node.SWIMDurationMin": 0,
        "node.SWIMDurationMax": 0,
        "node.activityType": 0,
        "node.VO2maxPct": 0,
        "node.activityNameTmp": 0
      },
      defaultItem: {
        "node.activityId": "",
        "node.activityName": 0,
        "node.activityDescription": 0,
        "node.activityCategory": 0,
        "node.USCode": 0,
        "node.EUCode": 0,
        "node.CANCode": 0,
        "node.HRMinPct": 0,
        "node.HRMaxPct": 0,
        "node.DURATIONMin": 0,
        "node.DURATIONMax": 0,
        "node.WORKRest": 0,
        "node.SWIMDurationMin": 0,
        "node.SWIMDurationMax": 0,
        "node.activityType": 0,
        "node.VO2maxPct": 0,
        "node.activityNameTmp": 0
      }
    };
  },
  async created() {
    await this.$store
      .dispatch("allActivity")
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        console.error(error);
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(["activityList"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Activity" : "Edit Activity";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    handleGetActivityList() {
      //reach out of Vuex store, fire action that gets Activitys
      this.$store.dispatch("allActivity");
    },
    handleAddActivity() {
      // if (this.$ref.dialog.validate()) {
      // check for any rules validations on the form

      /*
        "ActivityId:" + this.editedItem.ActivityId+
"ActivityName:" + this.editedItem.ActivityName+
"ActivityLastname:" + this.editedItem.ActivityLastname+
"status:" + this.editedItem.status+
"birthDate:" + this.editedItem.birthDate+
"photo:" + this.editedItem.photo+
"gender:" + this.editedItem.gender+
"ActivityEmail:" + this.editedItem.ActivityEmail+
"language:" + this.editedItem.language+
"country:" + this.editedItem.country+
"createDate:" + this.currentDate+
"updateSource:" + "VueJS tst"+
"teamId:" + this.editedItem.teamId
      );*/

      this.$store.dispatch("addActivity", {
        ActivityId: this.editedItem.ActivityId || 0,
        // Number(this.editedItem.ActivityId) + Math.floor(Math.random() * 100),
        ActivityName: this.editedItem.ActivityName,
        ActivityLastname: this.editedItem.ActivityLastname,
        status: this.editedItem.status,
        birthDate: this.editedItem.birthDate,
        photo: this.editedItem.photo,
        gender: this.editedItem.gender,
        ActivityEmail: this.editedItem.ActivityEmail,
        language: this.editedItem.language,
        country: this.editedItem.country,
        createDate: this.currentDate,
        updateSource: "VueJS tst",
        teamId: this.editedItem.teamId
      });
      //}
    },
    handleDeleteActivity() {
      // if (this.$ref.dialog.validate()) {
      // check for any rules validations on the form

      this.$store.dispatch("DeleteActivity", {
        ActivityId: this.editedItem.ActivityId
      });
      //}
    },
    editItem(item) {
      this.editedIndex = this.handleGetActivityList.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.handleGetActivityList.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
        // this.handleGetActivityList.splice(index, 1);
        this.handleDeleteActivity(index);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.handleAddActivity();
      /*
      if (this.editedIndex > -1) {
        Object.assign(
          this.handleGetActivityList.toString()[this.editedIndex],
          this.editedItem
        );
      } else {
        
        // this.handleGetActivityList.push(this.editedItem);
        this.handleAddActivity;
      }*/
      this.close();
    }
  },
  mounted() {}
};
</script>
